<template>
	<div class="referee">
		<p class="title flex">裁判席</p>
		<p class="header row flex between">
			<span>序号</span>
			<span>身份</span>
			<span>姓名</span>
			<span>学号</span>
		</p>
		<div v-if="refereeList?.length===0" class="nodata"></div>
		<p v-for="(item,index) in refereeList" :key="index" class="row flex between">
			<span>{{index+1}}</span>
			<span>{{roleType[item.type]}}</span>
			<span class="text-ellipsis">{{item.studentName}}</span>
			<span>{{item.studentNumber}}</span>
		</p>
	</div>
</template>

<script>
export default {
	data() {
		return {
			// 0-选手 1-主裁判 2-副裁判 3-记录员
			roleType: ["选手", "主裁判", "副裁判", "记录员"],
		};
	},
	props: {
		refereeList: [],
	},
};
</script>

<style lang="less" scoped>
.referee {
	padding: 0 17 / @rem;
	p.title {
		font-size: 16 / @rem;
		font-family: Source Han Sans CN-Medium;
		font-weight: bold;
		padding: 11 / @rem 0;
	}

	.row {
		letter-spacing: 1 / @rem;
		height: 30 / @rem;
		span {
			text-align: center;
			&:nth-child(1) {
				width: 15%;
			}
			&:nth-child(2) {
				width: 15%;
			}
			&:nth-child(3) {
				flex: 1;
			}
			&:nth-child(4) {
				width: 25%;
			}
		}
	}

	.header {
		height: 38 / @rem;
		background: #fff6e9;
		border-radius: 12 / @rem;
		font-weight: bold;
	}
}
</style>
